import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import {
  newCheckInAction,
  NEW_CHECKIN,
} from '../../actions/navigation';
import { useConfig } from '../../config/ConfigContext';

export const Waiting = (props) => {
  const config = useConfig();
  const { checkinData, params, searchParams } = props;
  const workflowType = get(params, 'workflowType');
  const key = searchParams.get('key');
  const [timerId, setTimerId] = useState(null);

  useEffect(() => {
    const timer = setInterval(() => {
      if (
        get(props.checkinData, ['data', 'url']).split('?')[0] === '/income/waiting'
        || get(props.checkinData, ['data', 'url']).split('?')[0] === `/${workflowType}/income/waiting`
      ) {
        props.dispatch(newCheckInAction({
          key,
          workflowType: workflowType || 'text2apply',
          data: {
            checkStatus: true,
          },
        }));
      } else {
        clearTimeout(timerId);
      }
    }, 5000);

    setTimerId(timer);

    const { navigate } = props;

    if (get(checkinData, ['data', 'data']) === undefined) {
      navigate(`${workflowType ? `/${workflowType}` : ''}/?key=${key}`);
    }
  }, []);

  useEffect(() => {
    const { fetch, navigate } = props;
    if (fetch.isDone[`${NEW_CHECKIN}`] && !fetch.isRunning[`${NEW_CHECKIN}`]) {
      const url = get(checkinData, ['data', 'url'], '');

      if (url.split('?')[0] !== (workflowType ? `/${workflowType}/income/waiting` : '/income/waiting')) {
        clearTimeout(timerId);
        const routeUrl = url.replace(config.hostUrl, '');
        navigate(`${routeUrl}`);
      }
    }
  }, [checkinData]);

  return (
    <div className="transition-item wrapper v-center">
      <div className="overlay-container">
        <h2 className="loading-message">Loading your account information. Please wait...</h2>
      </div>
    </div>
  );
};

Waiting.propTypes = {
  navigate: PropTypes.func.isRequired,
  checkinData: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  fetch: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  searchParams: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  checkinData: state.screen.checkinData,
  fetch: state.fetch,
});

export default connect(mapStateToProps)(Waiting);
